<p-toast></p-toast>
<div class="grid">
  <div class="sm:col-6">
    <button pButton icon="pi pi-print" label="Print" hidden="true" (click)="printTemplate()" class="p-button-outlined mb-2 mr-2"></button>
    <button pButton icon="pi pi-send" label="Send via email" (click)="sendMailConfirmation()" class="p-button-outlined mb-2 mr-2"></button>
    <button
      pButton
      icon="pi pi-pencil"
      label="Edit"
      *ngIf="invoiceDetailsHeader?.transactionStatus !== 'PAID'"
      class="p-button-outlined mb-2 mr-2"
      [routerLink]="['/app/invoice/edit-invoice/' + invoiceDetailsHeader?._id]"
    ></button>
  </div>
</div>
<div class="flex flex-column md:flex-row">
  <div class="col-12 md:col-9" #receipto>
    <div class="card py-8 px-6 md:px-8 overflow-auto">
      <div
        class="flex flex-column align-items-start md:flex-row md:align-items-center md:justify-content-between border-bottom-1 surface-border pb-5 min-w-max"
      >
        <div class="flex flex-column">
          <p-avatar size="xlarge" class="invoice-avatar">
            <img *ngIf="organizationLogo" [src]="organizationLogo" alt="organization-logo" />
          </p-avatar>
          <div class="my-3 text-xl font-bold" *ngIf="organizationLogo">
            {{ organization?.name }}
          </div>
          <div class="my-3 text-4xl font-bold text-900" *ngIf="!organizationLogo">
            {{ organization?.name }}
          </div>
          <span>{{ organization?.address }}</span>
          <span>{{ organization?.phoneNumber }}</span>
          <span>{{ organization?.email }}</span>
          <span>{{ organization?.website }}</span>
        </div>
        <div class="flex flex-column mt-5 md:mt-0">
          <div class="text-2xl font-semibold text-left md:text-right mb-3">INVOICE</div>
          <div class="flex flex-column">
            <div class="flex justify-content-between align-items-center mb-2">
              <span class="font-semibold mr-6">INVOICE #</span>
              <span>{{ invoiceDetailsHeader?.transactionUniqueCode || invoiceDetailsHeader?.transactionCode }}</span>
            </div>
            <div class="flex justify-content-between align-items-center mb-2">
              <span class="font-semibold mr-6">DATE</span>
              <span> {{ invoiceDetailsHeader?.createdAt | date: 'mediumDate' }}</span>
            </div>
            <div class="flex justify-content-between align-items-center" *ngIf="invoiceDetailsHeader?.transactionDueDate">
              <span class="font-semibold mr-6">DUE DATE</span>
              <span> {{ invoiceDetailsHeader?.transactionDueDate | date: 'mediumDate' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 mb-8 grid">
        <div class="col">
          <div class="mb-3 text-2xl font-medium">BILL TO</div>
          <span class="block mb-2">{{ invoiceDetailsHeader?.customer?.name | titlecase }}</span>
          <span class="block">
            {{ invoiceDetailsHeader?.customer?.address }}
          </span>
          <span class="block mb-1">
            {{ invoiceDetailsHeader?.customer?.city }}
          </span>
          <span class="block mb-1" *ngIf="invoiceDetailsHeader?.customer?.phoneNumber">
            Phone:
            {{ invoiceDetailsHeader?.customer?.phoneNumber }}
          </span>
          <span class="block mb-1" *ngIf="invoiceDetailsHeader?.customer?.email">
            Email Address:
            {{ invoiceDetailsHeader?.customer?.email }}
          </span>
        </div>

        <div class="col">
          <div class="flex justify-content-end align-items-start">
            @if (signAndStamp.stamp) {
              <img [src]="signAndStamp.stamp" alt="organization-stamp" class="sign-stamp" />
            }
            @if (signAndStamp.sign) {
              <img [src]="signAndStamp.sign" alt="organization-sign" class="sign-stamp" />
            }
          </div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full" style="border-collapse: collapse; table-layout: auto">
          <thead>
            <tr>
              <th class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">Name</th>
              <th
                *ngIf="!utilService.doesURLHaveText('sales')"
                class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3"
              >
                Description
              </th>
              <th class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">Quantity</th>
              <th class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">Unit Price</th>
              <th class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">Line Total</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of invoiceLineItems">
            <tr [ngClass]="!item?.description ? 'border-bottom-1 surface-border' : null">
              <td class="text-left py-3 white-space-nowrap">
                {{ item?.name }}
              </td>
              <td class="text-left py-3 px-3" *ngIf="!utilService.doesURLHaveText('sales')">
                {{ item?.description }}
              </td>
              <td class="text-right py-3 px-3">
                {{ item?.quantity }}
              </td>
              <td class="text-right py-3 px-3">
                {{
                  item?.convertedItemPrice
                    | currency
                      : (invoiceDetailsHeader?.currency
                          ? invoiceDetailsHeader?.currency?.symbol
                            ? invoiceDetailsHeader?.currency?.symbol
                            : invoiceDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}
              </td>
              <td class="text-right py-3">
                {{
                  item.convertedLineTotal
                    | currency
                      : (invoiceDetailsHeader?.currency
                          ? invoiceDetailsHeader?.currency?.symbol
                            ? invoiceDetailsHeader?.currency?.symbol
                            : invoiceDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-wrap justify-content-end mt-5 pb-3">
        <div class="w-full lg:w-6 pl-3 lg:pl-0 lg:pr-3 flex align-items-end mt-5 lg:mt-0">
          <ul class="list-none p-0 m-0 w-full">
            @if (invoiceDetailsHeader?.totalTaxes?.length) {
              <li class="flex justify-content-between mb-3">
                <span class="text-900">Subtotal</span>
                <span class="text-900 font-medium text-lg">
                  {{
                    invoiceDetailsHeader?.convertedOriginalNonDiscountAmount
                      | currency
                        : (invoiceDetailsHeader?.currency
                            ? invoiceDetailsHeader?.currency?.symbol
                              ? invoiceDetailsHeader?.currency?.symbol
                              : invoiceDetailsHeader?.currency?.code
                            : utilService.getCurrentCurrency())
                  }}
                </span>
              </li>
            }

            @if (invoiceDetailsHeader?.discount?.amount || invoiceDetailsHeader?.discount?.percentage) {
              <li class="flex justify-content-between mb-3">
                <span class="text-green-600">
                  {{ (invoiceDetailsHeader?.discount?.description ? invoiceDetailsHeader?.discount?.description : 'Discount') | titlecase }}
                </span>
                @if (invoiceDetailsHeader?.discount?.percentage) {
                  <span class="text-900 font-medium text-lg"> {{ invoiceDetailsHeader?.discount?.percentage }}% </span>
                } @else {
                  <span class="text-900 font-medium text-lg">{{
                    invoiceDetailsHeader?.discount?.amount
                      | currency
                        : (invoiceDetailsHeader?.currency
                            ? invoiceDetailsHeader?.currency?.symbol
                              ? invoiceDetailsHeader?.currency?.symbol
                              : invoiceDetailsHeader?.currency?.code
                            : utilService.getCurrentCurrency())
                  }}</span>
                }
              </li>

              <li class="flex justify-content-between mb-3 border-top-1 surface-border pt-3">
                <span class="text-900 font-medium">Total (Excl. of Tax)</span
                ><span class="text-900 font-medium text-lg">
                  {{
                    invoiceDetailsHeader?.convertedTransactionTotalAmount
                      | currency
                        : (invoiceDetailsHeader?.currency
                            ? invoiceDetailsHeader?.currency?.symbol
                              ? invoiceDetailsHeader?.currency?.symbol
                              : invoiceDetailsHeader?.currency?.code
                            : utilService.getCurrentCurrency())
                  }}</span
                >
              </li>
            }

            <li class="flex justify-content-between mb-3" *ngFor="let tax of invoiceDetailsHeader?.totalTaxes">
              <span class="text-900">{{ tax.name }} ({{ tax.percentage }}%)</span
              ><span class="text-900 font-medium text-lg">{{
                tax.convertedAmount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}</span>
            </li>

            <li class="flex justify-content-between border-top-1 surface-border py-3">
              <span class="text-900 font-bold text-lg">Total (Incl. of Tax)</span
              ><span class="text-900 font-medium text-lg">
                {{
                  invoiceDetailsHeader?.convertedAmount
                    | currency
                      : (invoiceDetailsHeader?.currency
                          ? invoiceDetailsHeader?.currency?.symbol
                            ? invoiceDetailsHeader?.currency?.symbol
                            : invoiceDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span
              >
            </li>

            <span *ngFor="let paymentRecord of invoicePaymentRecords">
              <li class="flex justify-content-between mb-3">
                <span class="text-900">Payment on {{ paymentRecord.createdAt | date }} using {{ paymentRecord.paymentTerm }}: </span
                ><span class="text-900 font-medium text-lg">{{
                  paymentRecord.paidInCurrencyAmount
                    | currency
                      : (invoiceDetailsHeader?.currency
                          ? invoiceDetailsHeader?.currency?.symbol
                            ? invoiceDetailsHeader?.currency?.symbol
                            : invoiceDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span>
              </li>
            </span>
            <li class="flex justify-content-between border-top-1 surface-border py-3" *ngIf="invoiceDetailsHeader?.convertedTransactionBalance">
              <span class="text-900 font-bold">Amount Due</span
              ><span class="text-900 font-bold text-lg">{{
                invoiceDetailsHeader?.convertedTransactionBalance
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex flex-wrap justify-content-start mt-5 pb-3" *ngIf="organization?.printoutSettings?.invoice?.privacyPolicy">
        <div>
          <h6>Notes/Terms</h6>
          <div [innerHTML]="organization?.printoutSettings?.invoice?.privacyPolicy" class="w-full"></div>
          <div class="mt-2">
            {{ invoiceDetailsHeader?.customerNotes }}
          </div>
        </div>
      </div>
      <div class="flex align-content-center justify-content-center border-top-1 surface-border pt-4 text-center">
        {{ organization?.printoutSettings?.invoice?.tagline ? organization?.printoutSettings?.invoice?.tagline : 'Thank you for your business' }}
      </div>
      <div>
        <app-receipt-footer></app-receipt-footer>
      </div>
    </div>
  </div>
  <div class="col-12 md:col-3">
    <div class="card">
      <div class="surface-section">
        <div class="flex align-items-center">
          <div class="col">
            <div class="font-medium text-xl text-900 mb-3">Payment Summary</div>
            <div class="text-500">
              <div class="flex align-items-center text-700 flex-wrap"></div>
            </div>
          </div>
        </div>
        <ul class="list-none p-0 m-0">
          <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-4 font-medium">Total</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.convertedAmount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-4 font-medium">Balance</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.convertedTransactionBalance
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-4 font-medium">Status</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1 line-height-3">
              <span *ngIf="invoiceDetailsHeader?.transactionStatus">
                <p-dropdown
                  [options]="transactionStatus"
                  [(ngModel)]="selectedTransactionStatus"
                  placeholder="Select a Status"
                  (onChange)="updateTransaction()"
                  [disabled]="invoiceDetailsHeader?.transactionStatus === 'PAID' || invoiceDetailsHeader?.transactionStatus === 'DRAFT'"
                >
                  <ng-template pTemplate="selectedItem">
                    <p-tag
                      [severity]="
                        selectedTransactionStatus === transactionStatusEnum.APPROVED
                          ? 'success'
                          : selectedTransactionStatus === transactionStatusEnum.PENDING
                            ? undefined
                            : selectedTransactionStatus === transactionStatusEnum.DRAFT
                              ? 'danger'
                              : 'info'
                      "
                      [value]="selectedTransactionStatus"
                    ></p-tag>
                  </ng-template>
                  <ng-template let-transactionType pTemplate="item">
                    <p-tag
                      [severity]="
                        transactionType === transactionStatusEnum.APPROVED
                          ? 'success'
                          : transactionType === transactionStatusEnum.PARTIALLYPAID
                            ? 'warning'
                            : transactionType === transactionStatusEnum.PAID
                              ? 'info'
                              : transactionType === transactionStatusEnum.PENDING
                                ? undefined
                                : transactionType === transactionStatusEnum.DRAFT
                                  ? 'danger'
                                  : 'info'
                      "
                      [value]="transactionType ?? '--'"
                    ></p-tag>
                  </ng-template>
                </p-dropdown>
              </span>
            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-4 font-medium" *ngIf="invoicePaymentRecords && invoicePaymentRecords.length > 0">History</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"></div>

            <div class="flex align-items-center w-full mt-2" *ngFor="let record of invoicePaymentRecords; let i = index">
              <div class="col-11">
                <div class="flex align-items-center justify-content-between">
                  <p class="m-0">Payment #{{ i + 1 }}</p>
                  <h6 class="m-0">
                    {{
                      record?.paidInCurrencyAmount
                        | currency
                          : (invoiceDetailsHeader?.currency
                              ? invoiceDetailsHeader?.currency?.symbol
                                ? invoiceDetailsHeader?.currency?.symbol
                                : invoiceDetailsHeader?.currency?.code
                              : utilService.getCurrentCurrency())
                    }}
                  </h6>
                </div>
                <span class="text-sm text-color-secondary">{{ record?.createdAt | date }}</span>
              </div>
            </div>

            <p-menu #menu [model]="items" [popup]="true"></p-menu>
          </li>
        </ul>

        <div class="text-right mt-4">
          <button
            *ngIf="!(invoiceDetailsHeader?.transactionStatus === 'PAID') && !(invoiceDetailsHeader?.transactionStatus === 'DRAFT')"
            pButton
            label="Add payment"
            icon="pi pi-money-bill"
            (click)="openPaymentDialog()"
          ></button>
          <button
            *ngIf="invoiceDetailsHeader?.transactionStatus === 'DRAFT'"
            pButton
            label="Approve"
            icon="pi pi-check"
            class="p-button-success"
            (click)="approveInvoice()"
          ></button>
        </div>
      </div>
    </div>

    <!-- Cost & Revenue Summary Card -->
    <div class="card mt-4">
      <!-- [appPermission]="[
                ORGANIZATION_PERMISSION_TYPE.ADMIN,
                ORGANIZATION_PERMISSION_TYPE.OWNER,
                ORGANIZATION_PERMISSION_TYPE.INVOICES_ADMIN,
                ORGANIZATION_PERMISSION_TYPE.INVOICES_CREATOR_ONLY,
                ORGANIZATION_PERMISSION_TYPE.INVOICES_READ_WRITE_ONLY,
                ORGANIZATION_PERMISSION_TYPE.INVOICES_READ_ONLY
            ]" -->
      <div class="surface-section p-4">
        <div class="font-medium text-xl text-900 mb-3">Cost & Revenue Summary</div>
        <ul class="list-none p-0 m-0">
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-6 font-medium">Total Revenue (Excl. Tax)</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.convertedTransactionTotalAmount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-6 font-medium">Total Cost of Goods</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.convertedTransactionTotalCostAmount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-6 font-medium">Total Gross Profit</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1 font-medium">
              {{
                invoiceDetailsHeader?.transactionTotalProfit
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-6 font-medium">Gross Profit Margin</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1 font-medium">
              {{
                ((invoiceDetailsHeader?.transactionTotalProfit ?? 0) / (invoiceDetailsHeader?.convertedTransactionTotalAmount ?? 1)) * 100
                  | number: '1.2-2'
              }}%
            </div>
          </li>
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-6 font-medium">Total Taxes</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.convertedTaxTotal
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-2 px-2 border-top-1 surface-border flex-wrap" *ngIf="invoiceDetailsHeader?.discount?.amount">
            <div class="text-500 w-full md:w-6 font-medium">Discount Applied</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1">
              {{
                invoiceDetailsHeader?.discount?.amount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
          <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap surface-section">
            <div class="text-700 w-full md:w-6 font-bold">Net Revenue (Incl. Tax)</div>
            <div class="text-900 w-full md:w-6 md:text-right md:flex-order-0 flex-order-1 font-bold text-lg">
              {{
                invoiceDetailsHeader?.convertedAmount
                  | currency
                    : (invoiceDetailsHeader?.currency
                        ? invoiceDetailsHeader?.currency?.symbol
                          ? invoiceDetailsHeader?.currency?.symbol
                          : invoiceDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}
            </div>
          </li>
        </ul>
        <div class="mt-3 pt-2 border-top-1 surface-border">
          <span class="text-sm text-500">*Profit figures exclude operating expenses</span>
        </div>
      </div>
    </div>
  </div>
  <p-dialog
    header="Add a payment"
    [(visible)]="paymentDialog"
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="flex flex-wrap gap-3 p-fluid">
      <form [formGroup]="addPaymentForm" class="w-full">
        <div class="flex align-items-start field-space-btwn">
          <div class="col-2">
            <label for="paidInCurrency">Currency</label>
            <input formControlName="paidInCurrency" id="paidInCurrency" type="text" pInputText />
          </div>
          <div class="col-10">
            <label for="paidInCurrencyAmount">Amount</label>
            <p-inputNumber inputId="paidInCurrencyAmount" formControlName="paidInCurrencyAmount"> </p-inputNumber>
          </div>
        </div>

        <div class="flex-auto">
          <label for="paymentTerm">Paid with</label>
          <p-dropdown
            appendTo="body"
            inputId="paymentTerm"
            formControlName="paymentTerm"
            [options]="organizationPaymentTerms"
            placeholder="Select payment term"
          ></p-dropdown>
        </div>
      </form>
    </div>
    <div class="mt-4 text-right">
      <button
        label="Cancel"
        pButton
        type="button"
        icon="pi pi-times"
        iconPos="left"
        (click)="paymentDialog = false"
        class="p-button-danger mr-2"
      ></button>

      <button label="Save" pButton type="button" icon="pi pi-plus" iconPos="left" (click)="addPayment()" [disabled]="!addPaymentForm.valid"></button>
    </div>
  </p-dialog>
  <p-toast></p-toast>
</div>
<div style="display: none">
  <app-receipts-print-view
    [receiptDetailsHeader]="invoiceDetailsHeader"
    [receiptLineItems]="invoiceLineItems"
    [receiptPaymentRecords]="invoicePaymentRecords"
    [receiptType]="'INVOICE'"
    [sign]="signAndStamp.sign"
    [stamp]="signAndStamp.stamp"
  ></app-receipts-print-view>
</div>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
<p-dialog header="Send invoice to email" [(visible)]="sendEmailDialog" [modal]="true" [style]="{ width: '50vw' }">
  <div class="flex flex-column gap-4">
    <label for="username">Send to:</label>
    <input
      pInputText
      id="username"
      aria-describedby="username-help"
      placeholder="Ex. joe@ebmsuite.com, kyler@gmail.com..."
      [(ngModel)]="sendToEmail"
      [required]="true"
    />
    <small id="username-help">Use commas to separate multiple emails.</small>
    <div class="mt-4 text-right">
      <button
        label="Cancel"
        pButton
        type="button"
        icon="pi pi-times"
        iconPos="left"
        class="p-button-danger mr-2"
        (click)="sendEmailDialog = false"
      ></button>

      <button label="Send" pButton type="button" icon="pi pi-send" iconPos="left" [disabled]="!sendToEmail" (click)="sendEmail()"></button>
    </div>
  </div>
</p-dialog>
